/**
 * @generated SignedSource<<d9f0ae3146436cf383974506d640f80c>>
 * @relayHash 721de05816b4a23d4956957fad6733b2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7c1ca0f9ddc2648482e7ea8ed8bbfef84a3c38973644e78dc2f1db27d9257083

import type { ConcreteRequest, Query } from 'relay-runtime';
export type PTGraphQLPageStatus = "CURRENT" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
export type PageTreePreviousItemsQuery$variables = {
  contentId: string;
  isSuperAdmin: boolean;
  paginationLimit?: number | null | undefined;
  ptStatuses?: ReadonlyArray<PTGraphQLPageStatus | null | undefined> | null | undefined;
  spaceKey: string;
};
export type PageTreePreviousItemsQuery$data = {
  readonly currentPage: {
    readonly blank: boolean | null | undefined;
    readonly hasChildren: boolean;
    readonly hasInheritedRestrictions?: boolean;
    readonly hasRestrictions?: boolean;
    readonly id: string;
    readonly links: {
      readonly webui: string | null | undefined;
    } | null | undefined;
    readonly nearestAncestors: {
      readonly nodes: ReadonlyArray<{
        readonly blank: boolean | null | undefined;
        readonly hasChildren: boolean;
        readonly hasInheritedRestrictions?: boolean;
        readonly hasRestrictions?: boolean;
        readonly id: string;
        readonly links: {
          readonly webui: string | null | undefined;
        } | null | undefined;
        readonly previousSiblings: {
          readonly nodes: ReadonlyArray<{
            readonly blank: boolean | null | undefined;
            readonly hasChildren: boolean;
            readonly hasInheritedRestrictions?: boolean;
            readonly hasRestrictions?: boolean;
            readonly id: string;
            readonly links: {
              readonly webui: string | null | undefined;
            } | null | undefined;
            readonly properties: {
              readonly nodes: ReadonlyArray<{
                readonly id: string | null | undefined;
                readonly key: string | null | undefined;
                readonly value: string | null | undefined;
                readonly version: {
                  readonly number: number | null | undefined;
                } | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
            readonly status: PTGraphQLPageStatus | null | undefined;
            readonly subType: string | null | undefined;
            readonly title: string | null | undefined;
            readonly type: string | null | undefined;
          } | null | undefined> | null | undefined;
          readonly pageInfo: {
            readonly hasNextPage: boolean;
          } | null | undefined;
        } | null | undefined;
        readonly properties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null | undefined;
            readonly key: string | null | undefined;
            readonly value: string | null | undefined;
            readonly version: {
              readonly number: number | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly status: PTGraphQLPageStatus | null | undefined;
        readonly subType: string | null | undefined;
        readonly title: string | null | undefined;
        readonly type: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null | undefined;
    } | null | undefined;
    readonly previousSiblings: {
      readonly nodes: ReadonlyArray<{
        readonly blank: boolean | null | undefined;
        readonly hasChildren: boolean;
        readonly hasInheritedRestrictions?: boolean;
        readonly hasRestrictions?: boolean;
        readonly id: string;
        readonly links: {
          readonly webui: string | null | undefined;
        } | null | undefined;
        readonly properties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null | undefined;
            readonly key: string | null | undefined;
            readonly value: string | null | undefined;
            readonly version: {
              readonly number: number | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly status: PTGraphQLPageStatus | null | undefined;
        readonly subType: string | null | undefined;
        readonly title: string | null | undefined;
        readonly type: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null | undefined;
    } | null | undefined;
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null | undefined;
        readonly key: string | null | undefined;
        readonly value: string | null | undefined;
        readonly version: {
          readonly number: number | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly status: PTGraphQLPageStatus | null | undefined;
    readonly subType: string | null | undefined;
    readonly title: string | null | undefined;
    readonly type: string | null | undefined;
  } | null | undefined;
};
export type PageTreePreviousItemsQuery = {
  response: PageTreePreviousItemsQuery$data;
  variables: PageTreePreviousItemsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSuperAdmin"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "paginationLimit"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ptStatuses"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "title"
},
v7 = {
  "kind": "ScalarField",
  "name": "status"
},
v8 = {
  "kind": "ScalarField",
  "name": "hasChildren"
},
v9 = {
  "kind": "ScalarField",
  "name": "blank"
},
v10 = {
  "condition": "isSuperAdmin",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasRestrictions"
    },
    {
      "kind": "ScalarField",
      "name": "hasInheritedRestrictions"
    }
  ]
},
v11 = {
  "kind": "ScalarField",
  "name": "type"
},
v12 = {
  "kind": "ScalarField",
  "name": "subType"
},
v13 = {
  "concreteType": "Map_LinkType_String",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "webui"
    }
  ]
},
v14 = {
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "emoji-title-published",
        "emoji-title-draft",
        "editor"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v5/*: any*/),
        {
          "kind": "ScalarField",
          "name": "key"
        },
        {
          "kind": "ScalarField",
          "name": "value"
        },
        {
          "concreteType": "Version",
          "kind": "LinkedField",
          "name": "version",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "number"
            }
          ]
        }
      ]
    }
  ],
  "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
},
v15 = {
  "concreteType": "PTPageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v16 = {
  "concreteType": "PTPaginatedPageList",
  "kind": "LinkedField",
  "name": "previousSiblings",
  "plural": false,
  "selections": [
    {
      "concreteType": "PTPage",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v5/*: any*/),
        (v6/*: any*/),
        (v7/*: any*/),
        (v8/*: any*/),
        (v9/*: any*/),
        (v10/*: any*/),
        (v11/*: any*/),
        (v12/*: any*/),
        (v13/*: any*/),
        (v14/*: any*/)
      ]
    },
    (v15/*: any*/)
  ]
},
v17 = [
  {
    "alias": "currentPage",
    "args": [
      {
        "kind": "Literal",
        "name": "enablePaging",
        "value": true
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "pageTree",
        "variableName": "paginationLimit"
      },
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "ptStatuses"
      }
    ],
    "concreteType": "PTPage",
    "kind": "LinkedField",
    "name": "ptpage",
    "plural": false,
    "selections": [
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "nearestAncestors",
        "plural": false,
        "selections": [
          (v15/*: any*/),
          {
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v16/*: any*/)
            ]
          }
        ]
      },
      (v16/*: any*/)
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "PageTreePreviousItemsQuery",
    "selections": (v17/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "PageTreePreviousItemsQuery",
    "selections": (v17/*: any*/)
  },
  "params": {
    "cacheID": "721de05816b4a23d4956957fad6733b2",
    "id": "7c1ca0f9ddc2648482e7ea8ed8bbfef84a3c38973644e78dc2f1db27d9257083",
    "metadata": {},
    "name": "PageTreePreviousItemsQuery",
    "operationKind": "query",
    "text": "query PageTreePreviousItemsQuery($spaceKey:String!,$ptStatuses:[PTGraphQLPageStatus],$contentId:ID!,$paginationLimit:Int,$isSuperAdmin:Boolean!){currentPage:ptpage(id:$contentId,spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true){id,title,status,hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},nearestAncestors{pageInfo{hasNextPage},nodes{id,title,status,hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},previousSiblings{nodes{id,title,status,hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n            hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}}},previousSiblings{nodes{id,title,status,hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}}}"
  }
};
})();

(node as any).hash = "4d500f939ab5ebf8e00183c0d9277bcf";

export default node;
